<template>
    <div class="flex flex-col md:flex-row gap-4">
        <div
            class="flex-1 border-solid rounded-xl border-t-20 border-gold bg-grey p-6 flex flex-col items-center gap-3"
        >
            <img src="@/assets/img/graphics/eskd/heart-yellow.svg" alt="Heart icon" />

            <h5 class="text-2xl text-center">Cardiac workup</h5>

            <ul class="list-disc pl-4 font-light self-start">
                <li>
                    Serial ECG showed there were no signs of ischemia or conduction abnormalities, and no further
                    episodes of chest discomfort were reported
                </li>
                <li>
                    Thorax CT angiography showed no atheromatous disease of the aorta and no embolic source. There were
                    no other abnormalities
                </li>
                <li>
                    TTE revealed normal left and right ventricular size and systolic function. There was no interatrial
                    shunt upon injection of agitated saline and no intracardiac thrombus
                </li>
            </ul>
        </div>

        <div
            class="flex-1 border-solid rounded-xl border-t-20 border-darkerblue bg-grey p-6 flex flex-col items-center gap-3"
        >
            <img src="@/assets/img/graphics/eskd/person-icon.svg" alt="Human icon" />

            <h5 class="text-2xl text-center">Ischemia investigations</h5>

            <ul class="list-disc pl-4 font-light self-start">
                <li>
                    Arterial Doppler ultrasound to measure the blood flow of the lower limbs revealed normal PVR below
                    the knees, mildly abnormal PVR at the ankles, and severe ischemia at the metatarsals and digits
                    bilaterally
                </li>
                <li>
                    When repeated 10 days later, after warming the feet, there was no improvement in perfusion of the
                    second to fifth digits bilaterally and improvement to moderate ischemia in the great toes
                    bilaterally
                </li>
                <li>Bilateral X-rays of hands and feet showed no vascular or extraosseous calcification</li>
                <li>There was no hydronephrosis or nephrolithiasis</li>
            </ul>
        </div>
    </div>
</template>
